import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";

// GET_DROPDOWN_MASTER:"/v1/s/master/data",
// GET_DROPDOWN_COUNTRY:"/v1/s/master/country",
// GET_DROPDOWN_VOC:"/v1/s/master/voc",

export const createFutureCustomer = async (request, id) => {
  const url = `${APIEndpoint.POST_CREATEFUTURE}`;

  const res = await axiosInstance.post(url, JSON.stringify(request));
  return res;
};

export const searchFutureCustomer = (searchValues, pageValues) => {
  const api = `${APIEndpoint.SEARCH_FUTURE}`;

  let payload = {
    requestObject: {
      yearOfBudgets: searchValues.yearOfBudgets
        ? searchValues?.yearOfBudgets
        : [],
      companyType: searchValues.companyType ? searchValues.companyType : [],
      nationalityList: searchValues.nationalityList
        ? searchValues.nationalityList
        : [],
      industryType: searchValues.industryType ? searchValues.industryType : [],
      countryList: searchValues.countryList ? searchValues.countryList : [],
      statusList: searchValues.statusList ? searchValues.statusList : [],
      companyName: searchValues.companyName ? searchValues.companyName : "",
      contactName: searchValues.contactName ? searchValues.contactName : "",
      contactDateFrom: searchValues.contactDateFrom
        ? searchValues.contactDateFrom
        : "",
      contactDateTo: searchValues.contactDateTo
        ? searchValues.contactDateTo
        : "",
      areaSizeByRaiMin: searchValues.areaSizeByRaiMin
        ? searchValues.areaSizeByRaiMin
        : "",
      areaSizeByRaiMax: searchValues.areaSizeByRaiMax
        ? searchValues.areaSizeByRaiMax
        : "",
      areaSizeByNganMin: searchValues.areaSizeByNganMin
        ? searchValues.areaSizeByNganMin
        : "",
      areaSizeByNganMax: searchValues.areaSizeByNganMax
        ? searchValues.areaSizeByNganMax
        : "",
      areaSizeByWaMin: searchValues.areaSizeByWaMin
        ? searchValues.areaSizeByWaMin
        : "",
      areaSizeByWaMax: searchValues.areaSizeByWaMax
        ? searchValues.areaSizeByWaMax
        : "",
      areaSizeByMetersMax: searchValues.areaSizeByMetersMax
        ? searchValues.areaSizeByMetersMax
        : "",
      areaSizeByMetersMin: searchValues.areaSizeByMetersMin
        ? searchValues.areaSizeByMetersMin
        : "",
      waterConsumptionMin: searchValues.waterConsumptionMin
        ? searchValues.waterConsumptionMin
        : "",
      waterConsumptionMax: searchValues.waterConsumptionMax
        ? searchValues.waterConsumptionMax
        : "",
      wasteWaterMin: searchValues.wasteWaterMin
        ? searchValues.wasteWaterMin
        : "",
      wasteWaterMax: searchValues.wasteWaterMax
        ? searchValues.wasteWaterMax
        : "",
      kwMin: searchValues.kwMin ? searchValues.kwMin : "",
      kwMax: searchValues.kwMax ? searchValues.kwMax : "",
      areaType: searchValues.areaType ? searchValues.areaType : [],
      isInvestmentAdvice: searchValues.isInvestmentAdvice,
      isVisitAreaLandInfo: searchValues.isVisitAreaLandInfo,
      channels: searchValues.channels ? searchValues.channels : [],
      futureCustomerId: searchValues.futureCustomerId ? searchValues.futureCustomerId : ""
    },
    pageValue: {
      page: pageValues.page,
      pageSize: pageValues.pageSize,
      sortBy: pageValues.sortBy,
      sortDirection: pageValues.sortDirection,
    },
  };
  const res = axiosInstance.post(api, payload);

  return res;
};

export const updateFutureCustomer = async (requestbody) => {
  const url = `${APIEndpoint.PUT_UPDATEFUTURE}`;

  const res = await axiosInstance.put(url, JSON.stringify(requestbody));
  return res;
};

export const updateImageFutureCustomer = async (requestbody) => {
  const url = `${APIEndpoint.UPDATE_DASHBOARD_FUTURECUSTOMER}`;

  const res = await axiosInstance.put(url, JSON.stringify(requestbody));
  console.log(res)
  return res;
};

export const getFutureCustomer = async (id) => {
  const url = `${APIEndpoint.GET_FUTURE}`;

  const res = await axiosInstance.get(url + "/" + id);
  return res;
};

export const deleteFutureCustomer = (id) => {
  const api = APIEndpoint.DELETE_FUTURE + `/?futureCustomerId=${id}`;
  const res = axiosInstance.delete(api);
  return res;
};

export const exportFutureCustomer = async (searchValues) => {
  const url = `${APIEndpoint.EXPORT_FUTURE}`;

  let payload = {
    requestObject: {
      yearOfBudgets: searchValues.yearOfBudgets
        ? searchValues?.yearOfBudgets
        : [],
      companyType: searchValues.companyType ? searchValues.companyType : [],
      nationalityList: searchValues.nationalityList
        ? searchValues.nationalityList
        : [],
      industryType: searchValues.industryType ? searchValues.industryType : [],
      contactDateFrom: searchValues.contactDateFrom
        ? searchValues.contactDateFrom
        : "",
      contactDateTo: searchValues.contactDateTo
        ? searchValues.contactDateTo
        : "",
      areaSizeByRaiMin: searchValues.areaSizeByRaiMin
        ? searchValues.areaSizeByRaiMin
        : "",
      areaSizeByRaiMax: searchValues.areaSizeByRaiMax
        ? searchValues.areaSizeByRaiMax
        : "",
      areaSizeByNganMin: searchValues.areaSizeByNganMin
        ? searchValues.areaSizeByNganMin
        : "",
      areaSizeByNganMax: searchValues.areaSizeByNganMax
        ? searchValues.areaSizeByNganMax
        : "",
      areaSizeByWaMin: searchValues.areaSizeByWaMin
        ? searchValues.areaSizeByWaMin
        : "",
      areaSizeByWaMax: searchValues.areaSizeByWaMax
        ? searchValues.areaSizeByWaMax
        : "",
      areaSizeByMetersMax: searchValues.areaSizeByMetersMax
        ? searchValues.areaSizeByMetersMax
        : "",
      areaSizeByMetersMin: searchValues.areaSizeByMetersMin
        ? searchValues.areaSizeByMetersMin
        : "",
      waterConsumptionMin: searchValues.waterConsumptionMin
        ? searchValues.waterConsumptionMin
        : "",
      waterConsumptionMax: searchValues.waterConsumptionMax
        ? searchValues.waterConsumptionMax
        : "",
      wasteWaterMin: searchValues.wasteWaterMin
        ? searchValues.wasteWaterMin
        : "",
      wasteWaterMax: searchValues.wasteWaterMax
        ? searchValues.wasteWaterMax
        : "",
      kwMin: searchValues.kwMin ? searchValues.kwMin : "",
      kwMax: searchValues.kwMax ? searchValues.kwMax : "",
      areaType: searchValues.areaType ? searchValues.areaType : [],
      isInvestmentAdvice: searchValues.isInvestmentAdvice,
      isVisitAreaLandInfo: searchValues.isVisitAreaLandInfo,
      channels: searchValues.channels ? searchValues.channels : [],
    },
  };

  const res = await axiosInstance.post(url, JSON.stringify(payload));
  return res;
};

export const getDropDownMaster = async (topic_type) => {
  const url = `${APIEndpoint.GET_DROPDOWN_MASTER}`;

  const res = await axiosInstance.get(url + "/" + topic_type);
  return res;
};

export const getDropDownCountry = async () => {
  const url = `${APIEndpoint.GET_DROPDOWN_COUNTRY}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const getDropDownVOC = async (topic_type) => {
  const url = `${APIEndpoint.GET_DROPDOWN_VOC}`;

  const res = await axiosInstance.get(url + "/" + topic_type);
  return res;
};

// Customer Future
export const searchListByCompany = (companyName) => {
  const api = `${APIEndpoint.GET_LIST_BY_COMPANY}`;
  let payload = {
    requestObject: {
      companyName: companyName ? companyName : "",
    },
  };

  const res = axiosInstance.post(api, payload);
  return res;
};

export const getDropDownCurrentStatus = async () => {
  const url = `${APIEndpoint.GET_DROPDOWN_CURRENT_STATUS}`;

  const res = await axiosInstance.get(url);
  return res;
};

export const searchFutureCustomerAutocomplete = (autoCompleteKeyword) => {
  const api = `${APIEndpoint.SEARCH_FUTURE_AUTO_COMPLETE}`;
  let payload = {
    requestObject: {
      autoCompleteKeyword: autoCompleteKeyword ? autoCompleteKeyword : "",
    },
  };

  const res = axiosInstance.post(api, payload);
  return res;
};

export const searchListContacts = async (searchKey) => {
  const api = `${APIEndpoint.GET_LIST_CONTACTS}`;
  let payload = {
    requestObject: {
      searchKey: searchKey ? searchKey : "",
    },
    pageValue: {
      page: 0,
      pageSize: 100,
      sortBy: "label",
      sortDirection: "ASC"
    }
  };

  const res = axiosInstance.post(api, payload);
  return res;
};